export default __webpack_public_path__ + "static/facebook-68ecdab14cc35fa5d53e541a38ec8f45.png";